import { render, staticRenderFns } from "./CalendarWeekdays.vue?vue&type=template&id=5d4483c2&scoped=true&"
import script from "./CalendarWeekdays.vue?vue&type=script&lang=js&"
export * from "./CalendarWeekdays.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWeekdays.vue?vue&type=style&index=0&id=5d4483c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4483c2",
  null
  
)

export default component.exports